import React from 'react'

const MountainIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="mountainGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="rgba(140, 180, 220, 1)" />
          <stop offset="50%" stopColor="rgba(100, 140, 180, 1)" />
          <stop offset="100%" stopColor="rgba(80, 120, 160, 1)" />
        </linearGradient>
        <filter id="mountainGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Back mountain */}
      <path 
        d="M2 20l7-12 5 8 8-14 2 3v15H2z"
        fill="url(#mountainGradient)"
        opacity="0.6"
        filter="url(#mountainGlow)"
      />
      
      {/* Front mountain */}
      <path 
        d="M2 20l6-10 4 6 6-10 6 10v4H2z"
        fill="url(#mountainGradient)"
        filter="url(#mountainGlow)"
      />
      
      {/* Snow caps */}
      <path 
        d="M8 10l2-3 2 3h-4z"
        fill="rgba(255, 255, 255, 0.8)"
      />
      <path 
        d="M12 16l2-4 2 4h-4z"
        fill="rgba(255, 255, 255, 0.8)"
      />
    </svg>
  )
}

export default MountainIcon
